import moment from 'moment';
import {
  NEW_USER_REFERRAL_WINDOW_TIME,
  REFERRAL_CHARACTER_REWARD_STEP,
  MAX_LENGTH_REFERRAL_CODE,
  MIN_LENGTH_REFERRAL_CODE,
  REFERRER_REWARD_POINTS,
  CHARACTERS_PER_POINT,
  MAX_ALLOWED_REDEEM_CHARACTERS_PER_MONTH,
} from '@src/constants/referral';

export const checkUserEligibility = (user) => {
  // Check if user account creation date has exceed more than window time by day
  const exceededWindowTime = moment(user.createdAt).isBefore(
    moment().subtract(NEW_USER_REFERRAL_WINDOW_TIME, 'day'),
  );
  const hasAlreadyReferred = user?.referral?.referrerId;

  return !exceededWindowTime && !hasAlreadyReferred;
};

export const getReferralContent = (code, link) =>
  `Bạn đang tìm một giải pháp chuyển văn bản thành giọng nói nhanh, chuẩn và tự nhiên? Mình đang dùng Vbee và rất ấn tượng.\n\nĐặc biệt, khi đăng ký qua link sau, bạn sẽ nhận ngay 8.000 ký tự miễn phí ngày đầu.\n${link}\nHoặc nhập mã giới thiệu này sau khi tạo tài khoản: ${code}\n\nHãy trải nghiệm và đánh giá nhé.`;

export const getReferralCharacterReward = ({
  points,
  redeemedCharsThisMonth,
  limitRedeemCharacterEnabled = false,
}) => {
  if (!points || points < 0) return 0;
  const maxRewardCharacter = points * REFERRAL_CHARACTER_REWARD_STEP;
  const maxAllowedRedeemCharacters =
    MAX_ALLOWED_REDEEM_CHARACTERS_PER_MONTH - redeemedCharsThisMonth;
  return limitRedeemCharacterEnabled
    ? Math.min(maxRewardCharacter, maxAllowedRedeemCharacters)
    : maxRewardCharacter;
};

export const getValidateReferralCodeError = (code) => {
  const isValidCharacters = /^[A-Za-z0-9_-]+$/.test(code);
  const isTooShort = code.length < MIN_LENGTH_REFERRAL_CODE;
  const isTooLong = code.length > MAX_LENGTH_REFERRAL_CODE;
  const hasSpace = /\s/.test(code);

  const error = [
    {
      condition: isTooShort,
      key: 'referralCodeMinLength',
      params: { minLength: MIN_LENGTH_REFERRAL_CODE },
    },
    { condition: hasSpace, key: 'referralCodeSpace' },
    {
      condition: !isValidCharacters,
      key: 'referralCodeInvalidCharacters',
    },
    {
      condition: isTooLong,
      key: 'referralCodeMaxLength',
      params: { maxLength: MAX_LENGTH_REFERRAL_CODE },
    },
  ].find((e) => e.condition);

  return {
    key: error?.key,
    params: error?.params,
  };
};

export const calculateReferralStats = (referral) => {
  const earnedPoints = referral?.earnedPoints || 0;
  if (earnedPoints > 0) {
    const spentPoints = referral?.spentPoints || 0;

    return {
      totalUsers: Math.floor(earnedPoints / REFERRER_REWARD_POINTS),
      claimedChars: spentPoints * CHARACTERS_PER_POINT,
      unclaimedChars: CHARACTERS_PER_POINT * (earnedPoints - spentPoints),
    };
  }

  return {
    totalUsers: 0,
    claimedChars: 0,
    unclaimedChars: 0,
  };
};

export const extractReferralCodeFromUrl = (url) => {
  const urlObj = new URL(url);
  const { pathname } = urlObj;
  const referralCode = pathname.split('/').pop();
  return referralCode;
};
